/**
 * [GORIDE] Paidy あと払い訴求ウィジェット
 * Palo Alto の theme:variant:change イベントを受け取り、
 * data-amount を更新して Paidy ウィジェットを再描画する。
 */
(function () {
  'use strict';

  function formatPaidyAmount(priceInCents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.theme) {
      var format = window.theme.settings && window.theme.settings.currency_code_enable
        ? window.theme.moneyWithCurrencyFormat
        : window.theme.moneyFormat;
      return window.Shopify.formatMoney(priceInCents, format);
    }

    return String(priceInCents);
  }

  function getPaidyAmount(container, variant) {
    var priceEl = container.querySelector('[data-product-price]');
    if (priceEl && priceEl.textContent.trim()) {
      return priceEl.textContent.trim();
    }

    if (variant && typeof variant.price === 'number') {
      return formatPaidyAmount(variant.price);
    }

    return '';
  }

  function refreshPaidyWidget(widget, amount) {
    if (!widget || !amount) return;
    widget.setAttribute('data-amount', amount);
    if (typeof window._paidy === 'function') {
      window._paidy('pm:refresh');
    }
  }

  function onVariantChange(event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;

    var container = event.target && event.target.closest
      ? event.target.closest('[data-product]')
      : null;
    if (!container) return;

    var widget = container.querySelector('._paidy-promotional-messaging[data-goride-paidy]');
    refreshPaidyWidget(widget, getPaidyAmount(container, variant));
  }

  document.addEventListener('theme:variant:change', onVariantChange);
})();
